import React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import styled, { css } from 'styled-components/macro';
import { ReactComponent as DragHandleIcon } from '../../../../images/icons/drag-handle.svg';
import { spacing03 } from '../../../../styling/spacing';

type Props = {
  dragHandleProps: DraggableProvidedDragHandleProps | null;
  disabled?: boolean;
  className?: string;
};

export const DragHandle = ({ dragHandleProps, disabled, className }: Props) => {
  return (
    <DragHandleContainer {...dragHandleProps} $disabled={disabled} className={className}>
      <DragHandleIcon />
    </DragHandleContainer>
  );
};

const DragHandleContainer = styled.div<{ $disabled?: boolean }>`
  height: 24px;
  width: 24px;
  margin-right: ${spacing03};

  ${props =>
    props.$disabled
      ? css`
          display: none;
          pointer-events: none;
          cursor: default;
        `
      : null};
`;
